// 环境工具函数
export const env = {
  // 获取当前环境
  getCurrentEnv() {
    return process.env.NODE_ENV
  },

  // 获取API基础地址
  getBaseApi() {
    return process.env.VUE_APP_BASE_API
  },

  // 获取页面标题
  getTitle() {
    return process.env.VUE_APP_TITLE
  },

  // 检查是否启用Mock
  isMockEnabled() {
    return process.env.VUE_APP_MOCK === 'true'
  },

  // 获取超时时间
  getTimeout() {
    return parseInt(process.env.VUE_APP_TIMEOUT) || 10000
  },

  // 获取微信AppID
  getWechatAppId() {
    return process.env.VUE_APP_WECHAT_APP_ID || ''
  },

  // 获取微信JSSDK配置
  getWechatConfig() {
    return {
      appId: this.getWechatAppId(),
      debug: this.getCurrentEnv() === 'development',
      enableAuth: process.env.VUE_APP_WECHAT_AUTH === 'true',
      authScope: process.env.VUE_APP_WECHAT_AUTH_SCOPE || 'snsapi_userinfo'
    }
  },

  // 检测是否为微信浏览器
  isWechatBrowser() {
    const ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('micromessenger') !== -1
  },

  // 检测是否为移动端
  isMobile() {
    const ua = navigator.userAgent
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
  },

  // 打印环境信息（用于调试）
  logEnvInfo() {
    // console.group('🔧 环境信息')
    // console.log('当前环境:', this.getCurrentEnv())
    // console.log('API地址:', this.getBaseApi())
    // console.log('页面标题:', this.getTitle())
    // console.log('Mock状态:', this.isMockEnabled())
    // console.log('超时时间:', this.getTimeout())
    // console.log('微信AppID:', this.getWechatAppId())
    // console.log('微信授权:', this.getWechatConfig().enableAuth)
    // console.log('授权范围:', this.getWechatConfig().authScope)
    // console.log('是否微信浏览器:', this.isWechatBrowser())
    // console.log('是否移动端:', this.isMobile())
    // console.groupEnd()
  }
}

export default env
